export default __webpack_public_path__ + "static/media/takeaway.0e856618.svg";